import { Component, ElementRef, HostBinding, HostListener, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// The public pages' header (home page, /about): links, and a menu on small screens.
// It stays at the top as the page scrolls, slimmer once the page has moved.
@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.css'],
})
export class SiteHeaderComponent implements OnInit, OnDestroy {
  // Services is a section of the home page, so other pages link back to it
  @Input() onHomePage = false;
  // Fills the space around the header with the accent colour until the page scrolls (the home page's hero is accent)
  @HostBinding('class.tinted') @Input() tinted = false;

  @HostBinding('class.scrolled') scrolled = false;

  @ViewChild('menuButton') menuButton?: ElementRef<HTMLButtonElement>;

  isMobileMenuOpen = false;

  private readonly onScroll = () => {
    const scrolled = window.scrollY > 8;
    if (scrolled !== this.scrolled) {
      this.zone.run(() => (this.scrolled = scrolled));
    }
  };

  constructor(private host: ElementRef<HTMLElement>, private zone: NgZone, private router: Router) {}

  /**
   * This page's path, for its #section links: a bare href="#contact" resolves against <base href="/">, so on
   * /about it would load the home page instead of scrolling this one.
   */
  get pagePath(): string {
    return this.router.url.split(/[?#]/)[0];
  }

  ngOnInit(): void {
    this.onScroll();
    // Outside Angular, so scrolling only runs change detection when the header changes
    this.zone.runOutsideAngular(() => window.addEventListener('scroll', this.onScroll, { passive: true }));
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScroll);
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  // The #services / #contact links only scroll the page, so close the menu or it stays open over the section
  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeOnEscape(): void {
    if (this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
      this.menuButton?.nativeElement.focus();
    }
  }

  @HostListener('document:click', ['$event'])
  closeOnClickOutside(event: MouseEvent): void {
    if (this.isMobileMenuOpen && !this.host.nativeElement.contains(event.target as Node)) {
      this.isMobileMenuOpen = false;
    }
  }
}
